import { useContext, useMemo, useState } from "react";
import TabularContentList from "./TabularContentList";
import MaterialInput from "../../helperComponents/MaterialInput";
import SiteDropDownInput from "../../pages/loggedIn/employees/SiteDropDownInput";
import ZoneDropDownInput from "../../pages/loggedIn/sites/ZoneDropDownInput";
import AssignmentHistoryCard from "../../pages/loggedIn/assignmentHistory/AssignmentHistoryCard";
import employeeShiftTypes from "../../../data/employee/employeeShiftTypes";
import DropDownInput from "../../helperComponents/DropDownInput";
import contractTypesForSite from "../../../data/employee/contractTypesForSite";
import employeeTypes from "../../../data/employee/employeeTypes";
import { useTranslation } from "react-i18next";
import Context from "../../../Context";

let supportedFields = [
  "Zone Name",
  // "Site Codename",
  "Site Place Name",
  "Profile Nickname",
  "Profile Registration Number",

  "Profile Last Name",
  "Profile First Name",

  "Employee Responsibility",
  "Day Of Rest",

  "Shift",
  "Profile Is Active",

  // "Absence", //absence is rendered using custom cell so it is disabled here
  "Dispute",
  "Vacation",
];

let initialSelectedFields = [
  "Zone Name",
  "Site Place Name",
  //
  // "Profile Nickname",
  // "Site Codename",
  "Profile Registration Number",
  //

  "Profile Last Name",
  "Profile First Name",

  "Employee Responsibility",
  // "Day Of Rest",

  // "Shift",
  // "Profile Is Active",

  // "Dispute",
  // "Vacation",

  "Replacement User Registration Number",
  "Replacement User Last Name",
  "Replacement User First Name",
];

export default function TabularAssignmentHistory({
  userID,
  dateProp,
  shiftProp,
  setShiftProp,
  setDateProp,
  hideDateFilter,
  hideShiftFilter,
  disableTitle,
  readOnly,
  disableAllFilters,
}) {
  const { t } = useTranslation();
  const { employeeFunctions } = useContext(Context);
  const [zoneID, setZoneID] = useState(null);
  const [siteID, setSiteID] = useState(null);
  const [shift_, setShift_] = useState(null);
  const [employeeResponsibility, setEmployeeResponsibility] = useState(null);
  const [date_, setDate_] = useState(null);
  const [accountType, setAccountType] = useState("EMPLOYEE");
  const [isActive, setIsActive] = useState(null);

  let shift = shiftProp ? shiftProp : shift_;
  let setShift = setShiftProp ? setShiftProp : setShift_;

  let date = dateProp ? dateProp : date_;
  let setDate = setDateProp ? setDateProp : setDate_;

  const queryParams = useMemo(
    () => ({
      zoneID,
      siteID,
      date,
      shift,
      employeeResponsibility,
      accountType,
    }),
    [zoneID, siteID, date, shift, employeeResponsibility, accountType]
  );

  return (
    <TabularContentList
      disableAllFilters={disableAllFilters}
      readOnly={readOnly}
      hideFilterField={true}
      supportedFields={supportedFields}
      initialSelectedFields={initialSelectedFields}
      userID={userID}
      doReset={() => {
        setIsActive(null);
        setZoneID(null);
        setSiteID(null);
        setDate(null);
        setShift(null);
      }}
      queryParams={queryParams}
      filters={
        <>
          {hideDateFilter ? null : (
            <MaterialInput
              type="date"
              label={"Date"}
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          )}

          {hideShiftFilter ? null : (
            <DropDownInput
              label={"Shift"}
              options={employeeShiftTypes}
              value={shift}
              onChange={setShift}
            />
          )}

          <DropDownInput
            label={t("employeeResponsibility")}
            options={employeeFunctions || contractTypesForSite}
            value={employeeResponsibility}
            onChange={setEmployeeResponsibility}
          />

          {/* <DropDownInput
            label={t("Actif")}
            options={[
              { label: "OUI", value: "YES" },
              { label: "NON", value: "NO" },
            ]}
            value={isActive}
            onChange={setIsActive}
          /> */}

          <SiteDropDownInput onChange={setSiteID} value={siteID} label="Site" />
          <ZoneDropDownInput onChange={setZoneID} value={zoneID} label="Zone" />

          <DropDownInput
            options={employeeTypes}
            label={"Type du personnel"}
            value={accountType}
            onChange={setAccountType}
          />
        </>
      }
      title={disableTitle ? null : "Liste de présence"}
      path="assignment-history"
      CardComponent={AssignmentHistoryCard}
      nothingFoundMessage={
        date == null ? "Veuillez sélectionner la date" : null
      }
    />
  );
}
